export enum INVITATIONS_TYPE {
    DEVICE_SHARE = 0,
    TRANSFER_SITE = 1,
    ADD_CUSTOMER = 2,
    GROUP_TH_SHARE = 3,
}